export default __webpack_public_path__ + "ed047c9efe466f26a98afd538a49cada.png";